module.exports = require("@adc/ui-core");